export type ClockModeThemeSetting = {
    label: string;
    id: string;
    value: string;
    type: 'light' | 'dark';
    isCustom?: boolean;
};

export const ClockModeThemeSettings: ClockModeThemeSetting[] = [
    {
        label: "亮色",
        id: "light",
        value: "#ebebeb",
        type: "light",
    },
    {
        label: "烈红",
        id: "red",
        value: "#d34444",
        type: "light",
    },
    {
        label: "炙橙",
        id: "orange",
        value: "#e48a40",
        type: "light",
    },
    {
        label: "翠绿",
        id: "green",
        value: "#4fbb4d",
        type: "light",
    },
    {
        label: "青蓝",
        id: "cyan",
        value: "#51a2df",
        type: "light",
    },
    {
        label: "紫罗兰",
        id: "purple",
        value: "#9240db",
        type: "light",
    },
    {
        label: "淡红",
        id: "pink",
        value: "#f5d2d2",
        type: "light",
    },
    {
        label: "淡橙",
        id: "light-orange",
        value: "#f7d5b9",
        type: "light",
    },
    {
        label: "淡绿",
        id: "light-green",
        value: "#b4f3b3",
        type: "light",
    },
    {
        label: "淡蓝",
        id: "light-blue",
        value: "#aad1f0",
        type: "light",
    },
    {
        label: "淡紫",
        id: "light-purple",
        value: "#d9bdf2",
        type: "light",
    },
    {
        label: "青柠",
        id: "light-lime",
        value: "linear-gradient(0deg,rgba(87, 163, 46, 1) 0%, rgba(169, 207, 116, 1) 52%, rgba(247, 222, 57, 1) 100%)",
        type: "light",
    },
    {
        label: "晴空",
        id: "light-sunny",
        value: "linear-gradient(33deg,rgba(231, 233, 246, 1) 0%, rgba(42, 131, 217, 1) 100%)",
        type: "light",
    },
    {
        label: "都市",
        id: "light-city",
        value: "url('/clock-mode/bg/city.jpg')",
        type: "light",
    },
    {
        label: "森林",
        id: "light-forest",
        value: "url('/clock-mode/bg/forest.jpg')",
        type: "light",
    },
    {
        label: "高山",
        id: "light-mountain",
        value: "url('/clock-mode/bg/mountain.jpg')",
        type: "light",
    },
    {
        label: "云海",
        id: "light-cloud-sea",
        value: "url('/clock-mode/bg/cloud-sea.jpg')",
        type: "light",
    },
    {
        label: "天空",
        id: "light-sky",
        value: "url('/clock-mode/bg/sky.jpg')",
        type: "light",
    },

    {
        label: "暗色",
        id: "dark",
        value: "#0c0c0c",
        type: "dark",
    },
    {
        label: "紫幕",
        id: "dark-purple",
        value: "linear-gradient(0deg,rgba(72, 72, 168, 1) 0%, rgba(11, 22, 77, 1) 93%)",
        type: "dark",
    },
    {
        label: "地平线",
        id: "dark-horizon",
        value: "linear-gradient(0deg,rgba(112, 198, 230, 1) 0%, rgba(17, 48, 125, 1) 22%, rgba(16, 18, 38, 1) 37%, rgba(0, 0, 0, 1) 55%)",
        type: "dark",
    },
    {
        label: "夜湖",
        id: "dark-lake",
        value: "url('/clock-mode/bg/night-lake.jpg')",
        type: "dark",
    },
    {
        label: "上传图片",
        id: "custom-image",
        value: "",
        type: "light",
        isCustom: true,
    },
]

// 根据 ClockModeThemeSettings 的 id 自动生成类型
export type ClockModeThemeId = typeof ClockModeThemeSettings[number]['id'];